<template>
    <div>
        <div style="margin-top:50px;margin-left:50px;margin-right:50px;">
            <el-table
            :data="request_info"
            style="width:100%"
            stripe
            border>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="title" label="痛点名称" min-width="60%"></el-table-column>
                <el-table-column prop="create_time" label="提问时间" min-width="12%"></el-table-column>
                <el-table-column prop="name" label="提问人" min-width="10%"></el-table-column>
                <el-table-column prop="status" label="状态" min-width="8%"></el-table-column>
                <el-table-column prop="operations" label="操作" min-width="10%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="color:#409EFF;font-weight:bold;"
                        @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button
                        type="text"
                        style="color:#F56C6C;font-weight:bold;"
                        :disabled="scope.row.status=='已发布' || scope.row.status=='已拒绝'"
                        @click="handleReject(scope.row.id)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <template #title>
                <div class="dialog-header">
                <span>{{ dialog_title }}</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <div class="dialog-content">
                <div style="text-align:left;margin-left:15px;margin-bottom:20px;">
                    <span>选择所属痛点目录</span>
                    <el-cascader
                        v-model="belong_painspot_type"
                        :options="painspot_navigation"
                        placeholder="选择痛点目录"
                        style="margin-left:10px;width:300px;"
                        clearable>
                    </el-cascader>
                    <span style="margin-left:20px;">配置痛点名称</span>
                    <el-input v-model="cur_info.title" placeholder="请输入痛点名称" style="margin-left:10px;width:250px;" clearable></el-input>
                    <el-button size="mini" icon="el-icon-document-checked" type="primary" style="margin-left:10px;" @click="createRichText" :disabled="this.cur_info.status=='已发布' || this.cur_info.status=='已拒绝'">提交</el-button>
                </div>
                <div class="create-container">
                    <quill-editor
                    v-model="content_add"
                    ref="myQuillEditor"
                    :options="editorOptions"
                    />
                </div>
            </div>
            </el-dialog>
            <el-dialog
            title="填写拒绝理由"
            :visible.sync="dialogVisible_reject"
            width="30%"
            class="rejuect_reason_dialog">
                <el-input v-model="reject_reason" type="textarea" :rows="3"></el-input>
                <div style="margin-top:15px;">
                    <el-button type="primary" size="mini" @click="rejuectApprove">提交</el-button>
                    <el-button type="primary" size="mini" @click="cancel_reject">取消</el-button>
                </div>
            </el-dialog>
            <div style="margin-top:10px;" v-if="request_info.length > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageinfo.current"
                    :page-sizes="pageinfo.page_sizes"
                    :page-size="pageinfo.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="pageinfo.count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
    components: { quillEditor },
    created() {
        this.getQuestionList();
    },
    data() {
        return {
            dialog_title: '',
            dialogVisible: false,
            dialogVisible_reject: false,
            // search_name: '',
            // search_role: '',
            request_info: [],
            // request_info: [
            //     {'title': '关键人才流失率高怎么办？', 'question_time': '2025-05-13', 'user_name': '付寅', 'status': '已发布'},
            //     {'title': '关键人才流失率高怎么办？', 'question_time': '2025-05-12', 'user_name': '付寅', 'status': '已拒绝'},
            //     {'title': '关键人才流失率高怎么办？', 'question_time': '2025-05-11', 'user_name': '付寅', 'status': '待处理'}],
            // details_info: [
            //     {'id': 1, 'title': '痛点1', 'datetime': '2025-03-14'}, 
            //     {'id': 3, 'title': '痛点2', 'datetime': '2025-04-12'},
            //     {'id': 5, 'title': '痛点3', 'datetime': '2025-02-11'},
            //     {'id': 7, 'title': '痛点4', 'datetime': '2025-05-24'},
            //     {'id': 9, 'title': '痛点5', 'datetime': '2025-05-05'}],
            // details_columns: [],
            // selectedRows: [],
            current_status: '',
            painspot_navigation: [],
            belong_painspot_type: [],
            content_add: '',
            reject_reason: '',
            reject_id: null,
            cur_info: {},
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 20,
                page_sizes: [1, 10, 20, 50, 100],
            },
            // question_title: '',
            // editor: null,
            // toolbar: null,
        }
    },
    methods: {
        // handleDialogOpened() {
        //     this.$nextTick(() => {
        //         // 新增粘贴事件监听
        //         const quill = this.$refs.myQuillEditor.quill;
        //         this.editor = quill.root;
        //         this.toolbar = quill.getModule('toolbar');
        //         this.editor.removeEventListener('paste', this.handlePasteImage);
        //         this.editor.addEventListener('paste', this.handlePasteImage);
        //         // 上传文件的监听
        //         this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
        //     })
        // },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            this.getQuestionList();
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            this.getQuestionList();
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        getQuestionList() {
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
            }
            getdata.getListP("getQuestionList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.request_info = resp.data.data;
                    this.pageinfo.count = resp.data.count;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 4000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        rejuectApprove() {
            let params;
            params = {
                qid: this.reject_id,
                reject_reason: this.reject_reason
            }
            getdata.getListP("rejectUserQuestion", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    }) 
                    this.dialogVisible_reject = false;
                    this.getQuestionList();         
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        cancel_reject() {
            this.dialogVisible_reject = false;
        },
        handleReject(rid) {
            this.reject_reason = '';
            this.reject_id = rid;
            this.dialogVisible_reject = true;
        },
        handleEdit(row) {
            this.cur_info = row;
            // this.question_title = row.title;
            this.dialog_title = '编辑提问';
            this.belong_painspot_type = [];
            // this.belong_painspot_navigation = [];
            this.painspot_title_add = '';
            this.content_add = '';
            this.getPainSpotNavigation();
        },
        getPainSpotNavigation() {
            getdata.getList("getPainSpotNavigation")
            .then(resp => {
                if(resp.data.code == 200){
                    this.painspot_navigation = resp.data.data;
                    this.getQuestionInfo();
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 4000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getQuestionInfo() {
            let params;
            params = {
                qid: this.cur_info.id,
            }
            getdata.getListP("getQuestionInfo", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.content_add = resp.data.data;
                    this.dialogVisible = true;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 4000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        createRichText() {
            if(!this.content_add){
                this.$message({
                    message: '提问内容为空！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }else if(this.belong_painspot_type.length!=2) {
                this.$message({
                    message: '所属痛点目录配置错误！',
                    type: "error",
                    duration: 4000,
                })
                return;
            }else{
                postdata.postList("convertQuestionToPainSpot", JSON.stringify({classification: this.belong_painspot_type[0], sub_class: this.belong_painspot_type[1], title: this.cur_info.title, content: this.content_add, pid: this.cur_info.id, user_id: this.cur_info.user_id}))
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: "success",
                        })
                        this.dialogVisible = false;
                        this.getQuestionList();
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 4000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
    }
}
</script>

<style scoped>
/* ::v-deep .el-input__inner {
    height: 28px;
    line-height: 28px;
}
::v-deep .el-select .el-input .el-select__caret {
    line-height: 28px;
} */
::v-deep .el-table th {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-table__row td {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
.rejuect_reason_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.el-button--text.is-disabled {
  color: #c0c4cc !important;
}
/* primary 按钮会自动保持 Element 默认的灰色效果 */
</style>

